// common
// import './webcomponent/custom-elements'
import '@ungap/custom-elements' // fix safari
// import '@lottiefiles/lottie-player'

import './fix-scrollbar-width'
import './menu'
import './details'
import './site-message'
// import './scrolled'
// import './photos'

// blocks
import './blocks/references-list'
import './blocks/home-references'

// webcomponents
import './webcomponent/vp-slider'

// eslint-disable-next-line no-console
console.log('Ok ! ')
